import * as React from "react";
import { Button, Body1 } from "@fluentui/react-components";
import { NewShiftsDialog } from "sh-application/components/common/NewShiftsDialog/NewShiftsDialog";
import StringsStore from "sh-strings/store";
import { InstrumentationService } from "sh-services";

export interface CancelSmartScheduleDialogProps {
    isOpen: boolean;
    onConfirm: () => void;
    onDismiss: () => void;
    /** Optional custom content inside dialog body */
    content?: React.ReactNode;
}

/**
 * Reusable Cancel Smart Schedule Generation confirmation dialog.
 * Encapsulates shared strings + structure used by Schedules and NewTagHeader.
 */
const styles = require("./CancelSmartScheduleDialog.scss");

export const CancelSmartScheduleDialog: React.FC<CancelSmartScheduleDialogProps> = ({
    isOpen,
    onConfirm,
    onDismiss,
    content
}) => {
    if (!isOpen) { return null; }
    const smartScheduleStrings = StringsStore().registeredStringModules.get("smartSchedule").strings;
    return (
        <NewShiftsDialog
            title={smartScheduleStrings.get("cancelJobPopupTitle")}
            isOpen={isOpen}
            onDismiss={onDismiss}
            content={
                <div className={styles.cancelJobDialogContent}>
                    {content || <Body1 />}
                </div>
            }
            actions={
                <div className={styles.cancelJobDialogActions}>
                <Button appearance="secondary" onClick={() => {
                    InstrumentationService.logEvent(InstrumentationService.events.SmartSchedulingBannerPopupCancelGeneratingClicked);
                    onConfirm();
                    }
                }>{smartScheduleStrings.get("cancelJobConfirmButton")}</Button>
                <Button appearance="primary" onClick={() => {
                    InstrumentationService.logEvent(InstrumentationService.events.SmartSchedulingBannerPopupKeepGeneratingClicked);
                    onDismiss();
                    }
                }>{smartScheduleStrings.get("cancelJobDismissButton")}</Button>
                </div>
            }
        />
    );
};

export default CancelSmartScheduleDialog;